import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm } from 'redux-form';
import uniqueId from 'lodash/uniqueId';

import ActionButton from '~/components/action-button/action-button';

function PaymentEdit(props) {
  let { handleSubmit } = props;
  let { payment_instruments } = props.fields;

  function addPayment() {
    payment_instruments.addField({_id: uniqueId()});
  }
  function removePayment(index) {
    payment_instruments.removeField(index);
  }

  return (
    <form onSubmit={ handleSubmit }>
      <table className="table">
        <thead>
          <tr>
            <th>Payment Type</th>
            <th>Tipping Enabled</th>
            <th>Shortcut in Register Page</th>
            <th>Fixed Payment Amount</th>
            <th>Reference Number Format</th>
          </tr>
        </thead>
        <tbody>
          {
            payment_instruments ? payment_instruments.map((p, index) => (
              <tr key={ p.id.value || p._id.value }>
                <td><input
                      className="form-control"
                      type="text"
                      placeholder="Enter payment's name"
                      value={ p.name.value }
                      disabled={ p.id.value }
                      onChange={ p.name.onChange } />
                </td>
                <td><input type="checkbox" checked={ p.tipping_enabled.checked } onChange={ p.tipping_enabled.onChange } /></td>
                <td><input type="checkbox" checked={ p.shortcut_enabled.checked } onChange={ p.shortcut_enabled.onChange } /></td>
                <td>
                  <input type="checkbox" checked={ p.fixed_amount_enabled.checked } onChange={ p.fixed_amount_enabled.onChange } style={{marginRight:10}}/>
                  <input type="number" value={ p.fixed_amount.value } onChange={ p.fixed_amount.onChange } disabled={!p.fixed_amount_enabled.checked}/>
                </td>
                <td>
                  <select value={p.reference_number_id.value} onChange={p.reference_number_id.onChange}>
                    <option value="0">Default</option>
                    {props.refFormats.map(ref=>(
                      <option
                        key={ref.id}
                        value={ref.id}>
                        {ref.name}
                        ({ref.format})
                      </option>
                    ))}
                  </select>
                </td>
                <td><ActionButton type="delete" onClick={ removePayment.bind(null, index) }>remove</ActionButton></td>
              </tr>
            )) : null
          }
        </tbody>
      </table>

      <ActionButton type="add" onClick={ addPayment }>Create New Payment Type</ActionButton>
    </form>
  );
}
PaymentEdit.propTypes = {
  fields: PropTypes.object,
  handleSubmit: PropTypes.func,
  refFormats: PropTypes.array,
};

export default reduxForm({
  form: 'paymentType',
  fields: [
    'payment_instruments[]._id',
    'payment_instruments[].id',
    'payment_instruments[].name',
    'payment_instruments[].tipping_enabled',
    'payment_instruments[].fixed_amount_enabled',
    'payment_instruments[].fixed_amount',
    'payment_instruments[].reference_number_id',
    'payment_instruments[].room_number',
    'payment_instruments[].shortcut_enabled',
    'payment_instruments[].to_pms_enabled',
  ]
})(PaymentEdit);



/** WEBPACK FOOTER **
 ** ./client/pages/settings/payments/payment-type-edit.js
 **/